export default "../css/29301bb0f4f78784efed13727cffd3cd.ttf";